import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';
import Tabs from '../../tabs/tabs';
import CommonCheck from '../common/commonCheck';
import TruckLoadRatio from '../common/loadRatio';
import FuelCalculator from '../common/fuelCalculator';
import AddressInformation from '../common/addressInformation';
import Spinner from '~/components/common/Spinner';
import RatioComp from '~/components/common/Ratio';
import {getRateAverage, getFuelPrice, removeRateCheck} from '~/modules/rate/actions';
import {modalChange} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';
import DateRange from '../common/dateRange';
import { getDistance } from '~/api/map'

class RateInspetion extends React.Component{
  constructor (props) {
    super(props);
    this.state = {
      value: 'Rate Check',
      chooseArr: ['Rate Check', 'Truck to load ratio', 'Fuel Surcharge Calculator'],
      condition: true,
      distance: 'undefined',
      dateRange: DateRange.THIRTY,
      equipment: '',
      loading: false,
    }
    this.unfoldSelect = this.unfoldSelect.bind(this);
    this.downSelect = this.downSelect.bind(this);
    this.myFunction = this.myFunction.bind(this);
  }
  componentWillMount () {
    const { pickup, dropOff, equipment } = this.props;
    const {dateRange} = this.state;
    this.setState({
      equipment: equipment
    }, ()=> {
      const { equipment } = this.state;
      this.props.getRateAverage({pickup, dropOff, equipment, interval:dateRange});
      this.props.getFuelPrice({pickup, dropOff});
      document.addEventListener('click', this.myFunction, false);
      this.getDistance(pickup, dropOff);
    }) 
    
  }
  componentWillUnmount(){
    document.removeEventListener('click', this.myFunction, false);
    this.props.removeRateCheck();
  }
  myFunction () {
    this.setState({condition: true});
  }
  getDistance (latLngFrom, latLgnTo) {
    getDistance(latLngFrom, latLgnTo).then(distance=> {
      this.setState({distance: distance});
    })
  }

  preCheck = (range) => {
    const { isProfessional, showUpgradeToMember } = this.props
    if([DateRange.SEVEN, DateRange.FIFTEEN].includes(range) && !isProfessional) {
      showUpgradeToMember();
      return false
    } 
    return true;
  }

  changeRange = (range) =>{
    this.setState({
      dateRange: range,
      loading: true,
    }, ()=>{
      const { pickup, dropOff } = this.props
      const {dateRange ,equipment} = this.state;
      this.props.getRateAverage({pickup, dropOff, equipment, interval: dateRange}).then(()=>{
        this.setState({
          loading: false,
        })
      })
    })
  }

  changeEquipment = (equipment) => {
    this.setState({
      equipment,
      loading: true,
    }, ()=>{
      const { pickup, dropOff  } = this.props;
      const {dateRange , equipment} = this.state;
      this.props.getRateAverage({pickup, dropOff, equipment, interval: dateRange}).then(()=>{
        this.setState({
          loading: false,
        })
      })

    })
  }
  render () {
    const arr = [this.props.sdRateAverage, this.props.fuelPrice, this.state.distance];
    if (arr.indexOf('undefined') !== -1){
      return (<div className={cs(css.main)}>
          <div className={css.spinnerLine}>
            <div className={css.spinner}>
              <Spinner scalable={true}/>
            </div>
          </div>
      </div>);
    }
    return (
      <div className={cs(css.main)}>
        <div className={cs(css.paging)}>{this.renderForm()}</div>
        <div className={cs(css.adapterPaging)}>
          <div className={cs(css.pagingtitle)}>
            <div className={cs(css.adapterTabs)}>
              <span className={cs(css.menuContent)} onClick={this.unfoldSelect}>{this.state.value}</span>
              <span
                className={cs(this.state.condition ? css.down : css.unfold)}
                onClick={this.unfoldSelect}
              ></span>
              <ul
                className={cs(css.wrapUl)}
                style={{display: this.state.condition ? 'none' : 'block'}}
              >
                {this.state.chooseArr.map(item =>
                  <li
                    className={cs(css.wrapItem)}
                    key={item}
                    value={item}
                    onClick={(event) => {this.downSelect(event, item)}}
                  >{item}</li>
                )}
              </ul>
            </div>
          </div>
          <div className={cs(css.adapterTabsContent)}>
            {
              this.state.value === 'Rate Check' ? this.check() : this.calculator()
            }
          </div>
        </div>
      </div>
    )
  }
  renderForm () {
    return (
      <div>
        <Tabs
          id='rateInspection'
          tabs={[
            {id: 'check', title: 'Rate Check', dataqa: 'Rate Check'},
            // {id: 'loadRatio', title: 'Truck to load ratio', dataqa: 'Truck to load ratio'},
            {id: 'calculator', title: 'Fuel Surcharge Calculator', dataqa: 'Fuel Surcharge Calculator'}
          ]}
          csTab={cs(css.tab)}
          csTabs={cs(css.tabs)}
          csTabActive={cs(css.tabActive)}
          content={{
              check: this.check(),
              // loadRatio: this.ratio(),
              calculator: this.calculator()
          }}
        />
      </div>
    )
  }
  check () {
    return (
      <div className={cs(css.inspecyionContent)}>
        <AddressInformation
          pick={this.props.pick}
          drop={this.props.drop}
        />
        <div className={css.selectGroup}>
          <RatioComp
            wrapClassName = {css.ratioWrap}
            defaultValue = {this.state.equipment}
            title = "Selected Equipment Type"
            onChange={this.changeEquipment}
          >
            <div className={css.ratioItem} label={"Flatbed"}>Flatbed</div>
            <div className={css.ratioItem} label={"Van"}>Van</div>
            <div className={css.ratioItem} label={"Reefer"}>Reefer</div>
          </RatioComp>
          <RatioComp
            wrapClassName = {css.ratioWrap}
            defaultValue = {DateRange.THIRTY}
            title = "Timeframe"
            preCheck={this.preCheck}
            onChange={this.changeRange}
          >
            <div className={css.ratioItem} label={DateRange.SEVEN}>7 days</div>
            <div className={css.ratioItem} label={DateRange.FIFTEEN}>15 days</div>
            <div className={css.ratioItem} label={DateRange.THIRTY}>30 days</div>
          </RatioComp>
        </div>
        
        <div className={cs(css.inspecyionLable)}>
          <CommonCheck
            distance={this.props.distance}
            price={this.props.price}
            sdRateAverage={this.props.sdRateAverage}
            fuelPrice={this.props.fuelPrice}
            loading={this.state.loading}
          />
        </div>
      </div>
    )
  }
  ratio () {
    return (
      <div className={cs(css.loadRatioContent)}>
        <AddressInformation
          pick={this.props.pick}
          drop={this.props.drop}
          equipment={this.props.equipment}
        />
        <div className={cs(css.loadRatioLable)}>
          <TruckLoadRatio
            optional="true"
            pick={this.props.pick}
            drop={this.props.drop}
            pickup={this.props.pickup}
            dropOff={this.props.dropOff}
            equipment={this.props.equipment}
          />
        </div>
      </div>
    )
  }
  calculator () {
    return (
      <div className={cs(css.calculatorContent)}>
        <AddressInformation
          pick={this.props.pick}
          drop={this.props.drop}
          equipment={this.props.equipment}
        />
        <div className={cs(css.calculatorLable)}>
          <FuelCalculator distance={this.props.distance}/>
        </div>
      </div>
    )
  }
  unfoldSelect (event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.setState({condition: !this.state.condition});
  }
  downSelect (event, k) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.setState({condition: !this.state.condition, value: k});
  }
}
export default connect(({rate,account}, {location: {query: {param}}}) => {
  const data = JSON.parse(param);
  const pickup = {
    lng: data.origin.lng,
    lat: data.origin.lat,
    city: data.origin.city,
    state: data.origin.state,
  };
  const dropOff = {
    lng: data.destination.lng,
    lat: data.destination.lat,
    city: data.destination.city,
    state: data.destination.state,
  };
  return {
    pick: data.origin.name,
    drop: data.destination.name,
    equipment: data.equipment,
    pickup: pickup,
    dropOff: dropOff,
    sdRateAverage: rate.sdRateAverage,
    distance:rate.sdSumDistance,
    price: rate.sdSumPrice,
    fuelPrice: rate.fuelPrice === '--' ? null : rate.fuelPrice,
    isProfessional : Number(account.accountLevel) > Number(account.premium)
  };
}, mapDispatch({
  getRateAverage: (props, data) => getRateAverage(data),
  getFuelPrice: (props, data) => getFuelPrice(data),
  removeRateCheck: (props) => removeRateCheck(),
  showUpgradeToMember: (props) => modalChange('pop', {
    source: 'load-list',
    type: 'pop_upgrade_to_new_professional',
  }),
}))(RateInspetion);



// WEBPACK FOOTER //
// ./src/components/rate/rateInspection/index.js